import React from "react";
import { Modal, Typography, Box, Backdrop, Button, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
};

const CancelPriceMdal = ({
  open,
  setOpen,
  sellingPriceRows,
  purchasePriceRows,
  setSellingPriceRows,
  setPurchasePriceRows,
  closePriceModal,
  getItemData,
  params,
  resetPurchasTable,
  resetSalesTable,
  setData
}) => {
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };

  const CancelFun = () => {
    
    if (params?.id) {
      getItemData(params?.id);
    } else {
      resetPurchasTable();
      resetSalesTable();
      setData((prev)=>({
        ...prev,
        purchaseAmt: 0,
        sellingprice: 0,
        salesTaxableAmt: 0,
        purchaseTaxableAmt: 0,

      }))
    }
    closePriceModal(false);
    setOpen(false);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Box sx={style}>
      <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Changes are not saved
                <IconButton aria-label="delete" onClick={handleClose}>
                  <Close sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              padding: "15px",
              // height:{xs:"400px",sm:'auto'},
            }}
          >
            <Typography
              sx={{ fontSize: "14px", fontWeight: 600, }}
            >
              Are you sure you want to cancel ?
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Button
            onClick={handleClose}
              variant="outlined"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              No
            </Button>
            {open && (
              <Button
              onClick={CancelFun}
                variant="contained"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                Yes
              </Button>
            )}
          </Box>
      </Box>
      {/* </Fade> */}
    </Modal>
  );
};

export default CancelPriceMdal;
